module.exports = __webpack_public_path__ + "2769dc0d9222d3a1039f2ad83436ad57.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/plugin-img004.png
// module id = 914
// module chunks = 3